var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"my-0 pa-0",attrs:{"fluid":""}},[_c('q-news-submenu'),_c('v-container',{staticClass:"px-5 site-width",attrs:{"fluid":""}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }